import React, { useState } from "react";
import axios from "axios";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import endPoint from "../../websitecomponents/redux/EndPoint/endpoint";

const ResellProduct = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [marginType, setMarginType] = useState("percent");
  const [marginValue, setMarginValue] = useState("");
  const [loading, setLoading] = useState(false);

  const token = localStorage.getItem("ResellerTokenData");

  const handleAddProduct = async () => {
    const value = marginValue?.toString().trim();

    if (value === "") return toast.error("Please enter margin value");

    const numericValue = Number(value);

    if (isNaN(numericValue)) return toast.error("Margin must be a number");
    if (numericValue < 0) return toast.error("Margin cannot be negative");

    const payload = {
      productId: id,
      marginType,
      marginValue: numericValue,
    };

    try {
      setLoading(true);

      const res = await axios.post(endPoint.ResellerAddProduct, payload, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      if (res.data.success) {
        toast.success("Product added successfully");
        navigate("/reseller/viewProduct");
      }
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to add product");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex justify-center items-center px-4 py-6">
      {/* CARD */}
      <div className="w-full max-w-8xl bg-white rounded-xl shadow-md p-8">
        {/* HEADER */}
        <div className="flex items-center justify-between mb-6">
          <button
            onClick={() => navigate(-1)}
            className="flex items-center gap-2 text-sm font-medium text-gray-900 bg-gray-200 hover:bg-gray-300 px-4 py-2 rounded-md transition"
          >
            ← Back
          </button>
          <div /> {/* for spacing */}
        </div>

        {/* FORM BOX */}
        <div className="border rounded-lg p-6 bg-gray-50">
          {/* Margin Type */}
          <div className="mb-5">
            <label className="block text-md font-medium mb-1 text-gray-1000">
              Margin Type
            </label>

            <select
              value={marginType}
              onChange={(e) => setMarginType(e.target.value)}
              className="w-full border px-4 py-2.5 rounded-md focus:outline-none focus:ring-1 focus:ring-gray-400"
            >
              <option value="percent">Percentage (%)</option>
              <option value="fixed">Fixed Amount (₹)</option>
            </select>
          </div>

          {/* Margin Value */}
          <div className="mb-6">
            <label className="block text-md font-medium mb-1 text-gray-1000">
              Margin Value
            </label>

            <input
              type="number"
              value={marginValue}
              onChange={(e) => {
                const val = e.target.value;
                if (Number(val) < 0) return;
                setMarginValue(val);
              }}
              placeholder="Enter margin"
              className="w-full border px-4 py-2.5 rounded-md focus:outline-none focus:ring-1 focus:ring-gray-400"
            />
          </div>

          {/* BUTTON */}
          <button
            onClick={handleAddProduct}
            disabled={loading || marginValue === ""}
            className="w-full bg-green-600 hover:bg-green-700 text-white py-3 rounded-md text-base font-medium transition disabled:opacity-50"
          >
            {loading ? "Adding Product..." : "Add Product"}
          </button>
        </div>

        {/* FOOTER */}
        <p className="text-xs text-gray-400 mt-5 text-center">
          Set your margin and start reselling
        </p>
      </div>
    </div>
  );
};

export default ResellProduct;